import {
	Box,
	Button,
	ClickAwayListener,
	Divider,
	FormControlLabel,
	FormGroup,
	List,
	Radio,
	Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useState } from 'react';
import { useBoundStore } from 'useStore';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';
import useBrandsData from 'views/Components/Shared/Queries/brandsQuery';
import { brandIcons } from './utils';

function Options({ closeTooltip, brands }) {
	const selectedBrand = useBoundStore(
		(state) => state.productMasterSelectedBrand
	);
	const setSelectedBrand = useBoundStore(
		(state) => state.setProductMasterSelectedBrand
	);
	const resetPricingSelectedBrand = useBoundStore(
		(state) => state.clearProductMasterSelectedBrand
	);

	return (
		<List
			sx={{ width: '340px', maxWidth: 340, bgcolor: 'background.paper' }}
			component="nav"
			aria-labelledby="nested-list-subheader"
			subheader={
				<Stack
					direction="row"
					spacing={2}
					alignItems="center"
					justifyContent="space-between"
				>
					<Typography
						sx={{
							color: 'rgba(0, 0, 0, 0.87)',
							fontFamily: 'Roboto',
							fontStyle: 'normal',
							fontSize: '16px',
							lineHeight: '24px',
							fontWeight: '700',
							letterSpacing: '0.15px',
							padding: '12px',
						}}
					>
						Brand:
					</Typography>
				</Stack>
			}
		>
			<Divider />

			<List component="div" disablePadding>
				<Box
					sx={{
						maxHeight: '210px',
						overflowY: 'auto',
					}}
				>
					<FormGroup sx={{ pl: 2 }}>
						{brands?.map((brand, index) => {
							const iconSrc = brandIcons[brand.brand];
							return (
								<FormControlLabel
									key={brand.brand}
									sx={{
										borderBottom:
											index === brands.length - 1
												? 'none'
												: '1px solid rgba(236, 240, 244, 1)',
									}}
									control={
										<Radio
											color="secondary"
											checked={brand.brand === selectedBrand}
											onChange={() => {
												if (brand.brand === selectedBrand) {
													resetPricingSelectedBrand();
												} else {
													setSelectedBrand(brand.brand);
												}
											}}
										/>
									}
									label={
										<Stack
											direction="row"
											spacing={1}
											alignItems="center"
											paddingTop={1}
											paddingBottom={1}
										>
											{iconSrc && <img src={iconSrc} alt={brand.brand} />}
											<Typography>{brand.brand}</Typography>
										</Stack>
									}
								/>
							);
						})}
					</FormGroup>
				</Box>
			</List>

			<Divider />

			<Button
				color="secondary"
				onClick={closeTooltip}
				sx={{
					mt: 1,
				}}
			>
				CERRAR
			</Button>
		</List>
	);
}

export default function BrandFilter() {
	const [open, setOpen] = useState(false);
	const brandsQuery = useBrandsData();
	const selectedBrand = useBoundStore(
		(state) => state.productMasterSelectedBrand
	);

	const handleTooltipClose = () => {
		setOpen(false);
	};

	const handleToggleTooltip = () => {
		setOpen((prev) => !prev);
	};

	const appliedFilters = selectedBrand.length > 0 ? 1 : 0;

	return (
		<ClickAwayListener onClickAway={handleTooltipClose}>
			<div>
				<LightTooltip
					PopperProps={{
						disablePortal: true,
					}}
					onClose={handleTooltipClose}
					open={open}
					disableFocusListener
					disableHoverListener
					disableTouchListener
					title={
						<Options
							closeTooltip={handleTooltipClose}
							brands={brandsQuery.data}
						/>
					}
				>
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
						sx={{
							padding: '12px',
							width: '182px',
							borderRadius: '4px',
							border: '1px solid rgba(0, 0, 0, 0.23)',
							cursor: 'pointer',
						}}
						onClick={handleToggleTooltip}
					>
						<Typography
							sx={{
								color: '#00000099',
								fontSize: '16px',
								fontFamily: 'Roboto',
								fontStyle: 'normal',
								fontWeight: '400',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							{appliedFilters > 0 ? `Brand (${appliedFilters})` : 'Brand'}
						</Typography>
						<ArrowDropDownIcon
							sx={{
								fill: '#0000008F',
								width: '24px',
								height: '24px',
							}}
						/>
					</Stack>
				</LightTooltip>
			</div>
		</ClickAwayListener>
	);
}
